import { render, staticRenderFns } from "./ApplicationArea.vue?vue&type=template&id=5efbfabe"
import script from "./ApplicationArea.vue?vue&type=script&lang=js"
export * from "./ApplicationArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SectionContainer: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/SectionContainer.vue').default})
